import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import { designTypesEnum } from "../../../../../../Helpers/EnumHelper";

export default function DesignTypeDropdown(props) {
  const { t } = useTranslation();
  var dropdownItems = [];

  Object.entries(designTypesEnum).forEach(([key, value]) => {
    if (key.includes(props.keyword))
      dropdownItems.push(
        <Dropdown.Item key={value} eventKey={value}>
          {key}
        </Dropdown.Item>
      );
  });

  const GetKeyByValue = (value) => {
    return Object.keys(designTypesEnum).find((key) => designTypesEnum[key] === value);
  };

  const HandleDropDownSelect = (val) => {
    props.designTypeDropDownOnChange(val);
  };
  const buttonString = GetKeyByValue(parseInt(props.selectedDesignType));

  return (
    <Dropdown onSelect={HandleDropDownSelect}>
      <Dropdown.Toggle variant="success" style={{ width: "100%" }}>
        {buttonString ? buttonString : t("DesignTypeButton")}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ width: "100%" }}>{dropdownItems}</Dropdown.Menu>
    </Dropdown>
  );
}
